import { gql } from 'graphql-request';

export const CHECK_REGISTRATION_QUERY = gql`
  query ($mapperId: String) {
    isUserRegisteredToGamification(mapperId: $mapperId) {
      status
      hasConsented
    }
  }
`;

export const REGISTER_USER_TO_SEQUENTIAL_TRIVIA = gql`
  mutation ($userName: String!, $region: String, $mapperId: String) {
    registerUserToGamification(
      userName: $userName
      region: $region
      mapperId: $mapperId
    ) {
      userName
    }
  }
`;

export const SEQUENTIAL_TRIVIA_QUERY = gql`
  query ($triviaCampaignId: ID!) {
    sequentialTriviaQuestions(triviaCampaignId: $triviaCampaignId) {
      triviaQuestions {
        id
        gameId
        campaignId
        questionText
        backgroundImage
        pointsForCorrectAnswer
        options {
          id
          optionText
          optionImage
        }
        userAnswerResponse {
          questionId
          userSelectedOptionId
          correctAnswerId
          isAnswerCorrect
        }
      }
      gameMetaData {
        gameId
      }
      campaignStatus
    }
  }
`;

export const SUBMIT_SEQUENTIAL_TRIVIA_ANSWER = gql`
  mutation (
    $gameId: String!
    $questionId: String!
    $userSelectedOptionId: String!
  ) {
    submitAnswer(
      submitAnswerInput: {
        gameId: $gameId
        questionId: $questionId
        userSelectedOptionId: $userSelectedOptionId
      }
    ) {
      questionId
      correctAnswerId
      isAnswerCorrect
      userSelectedOptionId
    }
  }
`;
